import type { ReactNode } from "react";
import { connect } from "react-redux";

import { InformationMessage } from "@/components";

import { SaveChanges } from "../save-changes";

interface ToolsBarStatusProps {
    /**
     * The current information message. When empty, the save status is shown instead.
     */
    information: string;
}

/**
 * Tools bar status slot, showing either the active information message or the save status.
 *
 * @param {ToolsBarStatusProps} props - The props for the ToolsBarStatus component.
 * @returns {ReactNode} The rendered ToolsBarStatus component.
 */
const ToolsBarStatusComponent = ({
    information,
}: ToolsBarStatusProps): ReactNode =>
    information ? (
        <InformationMessage message={information} />
    ) : (
        <SaveChanges />
    );

const mapStateToProps = ({ window }) => ({
    information: window.information,
});

export const ToolsBarStatus = connect(mapStateToProps)(ToolsBarStatusComponent);
